import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
    booleanAttribute,
    computed,
    input,
} from '@angular/core';
import type { Icon } from '@hyundai/assets';
import { FootnotesPipe } from '@hyundai/ng-common-lib';
import { M000C010ImageComponent } from '../../000-primitives/m000-c010-image/m000-c010-image.component';
import { M040C030BadgeComponent } from '../../040-content-structure/m040-c030-badge/m040-c030-badge.component';

@Component({
    selector: 'ui-m030-c020-teaser-allrounder',
    standalone: true,
    templateUrl: './m030-c020-teaser-allrounder.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, FootnotesPipe, M000C010ImageComponent, M040C030BadgeComponent],
})
export class M040C020TeaserAllrounderComponent {
    strongText = input<string>();
    list = input<Array<{ icon: Icon; text: string }>>();
    image = input.required<string>();
    imageAlt = input<string>('Default Teaser Bild');
    badge = input<string>();
    greyBackground = input(true, { transform: booleanAttribute });
    isFirstView = input.required({ transform: booleanAttribute });
    isReverse = input<boolean>();
    remove2xlAspectRatio = input(false, { transform: booleanAttribute });
    imageCaption = input<string | null>();

    heroImage = computed(() => ({
        image: this.image(),
        desktop: { width: 1600, height: 900 },
        tablet: { width: 1000, height: 563 },
        mobile: { width: 766, height: 431 },
    }));

    imageStyle = computed(() => {
        const remove2xlAspectRatio = this.remove2xlAspectRatio();
        return `h-full w-full aspect-[16/9] md:aspect-square xl:aspect-[16/9]  ${
            remove2xlAspectRatio ? '' : '2xl:aspect-[16/9]'
        }`;
    });
}
